(function () {
  const trigger = document.querySelector('.buy-whilst.only-not-fixed');
  const fixedBar = document.querySelector('.buy-whilst.only-fixed');
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function getChatNudge() {
    const agent = document.querySelector('shopify-agent') || document.querySelector('shopify-chat');
    return agent && agent.shadowRoot
      ? agent.shadowRoot.querySelector('.activator-nudge.activator-nudge--right')
      : null;
  }

  function updateChatNudge() {
    const nudge = getChatNudge();
    if (!nudge) return;

    if (!mobileQuery.matches) {
      nudge.style.removeProperty('bottom');
      nudge.style.removeProperty('transition');
      return;
    }

    nudge.style.setProperty('transition', 'bottom 0.35s ease', 'important');
    const buyBarVisible = !!(fixedBar && fixedBar.classList.contains('is-visible'));
    nudge.style.setProperty('bottom', buyBarVisible ? '75px' : '10px', 'important');
  }

  if (trigger && fixedBar && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          fixedBar.classList.toggle('is-visible', !entry.isIntersecting);
          updateChatNudge();
        });
      },
      { threshold: 0 }
    );

    observer.observe(trigger);
  }

  updateChatNudge();

  const chatObserver = new MutationObserver(updateChatNudge);
  chatObserver.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('resize', updateChatNudge);
})();
